import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between ml-1" }
const _hoisted_2 = { class: "text-subtitle-2 tab-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_Prompt = _resolveComponent("Prompt")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "my-0 ml-0 mr-n2 pa-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          (_ctx.promptListSorted != null && _ctx.promptListSorted.length > 0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2",
                class: "ma-0 pa-2",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_ctx.localPromptList != null && _ctx.localPromptList.length > 0)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          icon: "mdi-plus",
                          click: _ctx.addPrompt,
                          size: "x-large",
                          tooltip: "New Chat",
                          variant: "outlined",
                          density: "default",
                          color: "secondary"
                        }, null, 8, ["click"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_tooltip, {
                      text: "The prompt studio is currently in beta and may have bugs.",
                      location: "top"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_chip, _mergeProps(props, {
                          size: "small",
                          color: "secondary",
                          class: "mx-auto"
                        }), {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode(" BETA ")
                          ])),
                          _: 2,
                          __: [2]
                        }, 1040)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_v_tabs, {
                    modelValue: _ctx.selectedPrompt,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPrompt) = $event)),
                      _ctx.onTabChange
                    ],
                    direction: "vertical",
                    color: "primary",
                    "bg-color": "background",
                    class: "tabs mt-2"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promptListSorted, (p, index) => {
                        return (_openBlock(), _createBlock(_component_v_tab, {
                          key: `${index}_${p.id}`,
                          value: p.id
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_2, _toDisplayString(p.name), 1),
                            _createVNode(_component_v_btn, {
                              class: "optionsBtn",
                              variant: "text",
                              icon: "",
                              rounded: 0
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode("mdi-dots-vertical")
                                  ])),
                                  _: 1,
                                  __: [3]
                                }),
                                _createVNode(_component_v_menu, {
                                  activator: "parent",
                                  density: "compact"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, { density: "compact" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                          density: "compact",
                                          class: "mt-1 mb-0 mx-2 pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              variant: "text",
                                              size: "small",
                                              color: "warning",
                                              icon: "mdi-trash-can-outline",
                                              onClick: ($event: any) => (_ctx.deletePrompt(p.id))
                                            }, null, 8, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.promptListSorted != null && _ctx.promptListSorted.length > 0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "10",
                class: "ma-0 pa-2",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.selectedPrompt,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedPrompt) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promptListSorted, (p, index) => {
                        return (_openBlock(), _createBlock(_component_v_window_item, {
                          key: `${index}_${p.id}`,
                          value: p.id,
                          class: "prompt-scroll overflow-y-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Prompt, {
                              id: p.id
                            }, null, 8, ["id"])
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.localPromptList != null && _ctx.localPromptList.length === 0)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "4",
                xl: "3",
                class: "ma-0 pa-2",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    onClick: _ctx.addPrompt,
                    class: "ma-0 pa-2 card add-card",
                    color: "surface",
                    density: "compact",
                    variant: "elevated",
                    elevation: "12"
                  }, {
                    default: _withCtx(() => [
                      _cache[4] || (_cache[4] = _createElementVNode("p", null, "New prompt", -1)),
                      _createVNode(_component_v_icon, {
                        class: "add-icon",
                        icon: "mdi-plus"
                      })
                    ]),
                    _: 1,
                    __: [4]
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}